import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Divider, Typography, useMediaQuery } from '@mui/material'
import CookiesStorageService from '../../../services/CookiesStorageService'
import {
  retrieveSystemAdminUsers, systemAdminUsersResetAlertHandler,
} from '../../../redux/features/users/SystemAdminUsers/SystemAdminUsersThunk'
import SystemAdminUsersList from './SystemAdminUsersList'
import { selectSystemAdminUsers } from '../../../redux/features/users/SystemAdminUsers/SystemAdminUsersSlice'
import LoaderWithErrorHandler from '../../../components/PageHelpers/LoaderWithErrorHandler'
import LoadMoreBtn from '../../../components/PageHelpers/LoadMoreBtn'
import SearchBarV2 from '../../../components/PageHelpers/SearchBarV2'
import PageFilter from './PageFilters/index'
import UseTranslation from '../../../hooks/UseTranslation'

const SystemAdminUsers = () => {
  const dispatch = useDispatch()
  const systemAdminUsers = useSelector(selectSystemAdminUsers)
  const { t } = UseTranslation()

  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))

  useEffect(() => {
    dispatch(retrieveSystemAdminUsers({ resetQueries: true }))
  }, [])

  const username = CookiesStorageService.getUserName()

  return (
    <Box sx={styles.container}>
      <Box sx={styles.titleBox}>
        <Typography sx={styles.welcomeHeader}>{t?.Welcome}, {username ?? `${t?.User}`}</Typography>
        {!isXsScreen && (<SearchBarV2
          actionToDispatch={retrieveSystemAdminUsers}
          searchPlaceholder={t?.['Search for user by username, Company or E-mail address']}
          store={systemAdminUsers}
          customStyles={styles.searchBarContainer}
          sendQueryAsObject
          actionProps={{ pageNumber: 0 }}
        />)}
      </Box>
      <Box sx={styles.body}>
          <PageFilter />
        <Divider />
            <SystemAdminUsersList />
         <LoaderWithErrorHandler
          store={systemAdminUsers}
          resetAlertHandler={systemAdminUsersResetAlertHandler}
        />
      <LoadMoreBtn
        store={systemAdminUsers}
        actionToDispatch={retrieveSystemAdminUsers}
        sendQueryAsObject />
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    padding: { xs: '0 20px', sm: '0 70px' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  userListContainer: {
    display: 'flex',
    width: '100%',
  },
  welcomeHeader: {
    fontSize: { xs: '16px', sm: '24px' },
  },
  titleBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: '100%',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    svg: {
      fontSize: { xs: '20px', sm: 'unset' },
      marginTop: { xs: '10px', sm: 'unset' },
    },
  },
  searchBarContainer: {
    input: {
      fontSize: { xs: '14px', sm: 'unset' },
    },
  },
  optionsBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    flexWrap: { xs: 'wrap', md: 'nowrap' },
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '2%',
    width: '100%',
  },
  sortAddBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: { xs: 'space-between', sm: 'flex-end' },
    width: '100%',
  },
  filterBox: {
    marginTop: { xs: '20px', sm: 5 },
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterBtn: {
    right: 0,
    borderRadius: { xs: 4, sm: 'unset' },
    '& svg': {
      width: { xs: '12px', sm: '16px' },
      height: { xs: '12px', sm: '16px' },
    },
  },
  body: {
    width: '100%',
  },
  filterIcon: {
    textTransform: 'capitalize',
    color: 'text.hint',
    '& svg': {
      width: { xs: '12px', sm: '16px' },
      height: { xs: '12px', sm: '16px' },
    },
  },
  clearFilter: {
    marginLeft: { xs: '5px', sm: '10px' },
    fontSize: { xs: '11px', sm: '16px' },
  },
  listContainer: {
    height: 'auto',
    padding: { xs: '0 10px 20px 10px', sm: '0 23px 30px 30px' },
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #cfd8dc , 0 0 0 1px #f1f1f1',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    width: '100%',
    marginBottom: '1%',
  },
  filterAutoComplete: { alignSelf: 'baseline', paddingTop: '10px' },
}

export default SystemAdminUsers
